export { Modal, ModalBody, ModalFooter, ModalHeader } from "./component";
export type {
  ModalBodyProps,
  ModalFooterProps,
  ModalHeaderProps,
  ModalProps,
  ModalStrings,
  ModalStyleProps,
} from "./types";
